import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import TrialNotification from "../../Pages/Patient/TrialNotification";
import MainAccordion from "../Accordion/MainAccordion";
import CustomButton from "../UI/CustomButton";
import GeneralNotificationChannels from "./GeneralNotificationChannels";
import useGetTrialGeneralNotificationConfig from "../../hooks/useGetTrialGeneralNotificationConfig";
import useUpdateTrialGeneralNotificationConfigMutation from "../../hooks/useUpdateTrialGeneralNotificationConfigMutation";

const TrialNotificationAccordion = ({ trialId, trialStructure, setMessage, setTypeOfMessage }) => {
  const isSessionBased = trialStructure === "session_based";

  const { data: savedConfig, isLoading } = useGetTrialGeneralNotificationConfig({ trialId });
  const { mutate: updateConfig, isPending } = useUpdateTrialGeneralNotificationConfigMutation({
    trialId,
  });

  const [localConfig, setLocalConfig] = useState(null);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (savedConfig) {
      setLocalConfig(savedConfig);
      setIsDirty(false);
    }
  }, [savedConfig]);

  const handleToggle = (field, value) => {
    setLocalConfig((prev) => ({ ...prev, [field]: value }));
    setIsDirty(true);
  };

  const handleSave = () => {
    const { id, trial, ...channels } = localConfig;
    updateConfig(channels, {
      onSuccess: () => {
        setIsDirty(false);
        toast.success("Notification settings saved");
      },
      onError: () => toast.error("Failed to save notification settings"),
    });
  };

  return (
    <MainAccordion
      title="Notifications"
      data={
        <Box sx={{ position: "relative", width: "100%", mb: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <GeneralNotificationChannels
                config={localConfig}
                isLoading={isLoading}
                isSessionBased={isSessionBased}
                onToggle={handleToggle}
              />
            </Box>
            <CustomButton size="small" disabled={!isDirty || isPending} onClick={handleSave}>
              Save
            </CustomButton>
          </Box>

          {!isSessionBased && (
            <>
              <Divider sx={{ my: 2 }} />
              <TrialNotification
                trialId={trialId}
                setMessage={setMessage}
                setTypeOfMessage={setTypeOfMessage}
              />
            </>
          )}
        </Box>
      }
    />
  );
};

export default TrialNotificationAccordion;
